module.exports = __webpack_public_path__ + "static/media/fortransmittal.6410a6f3.png";